/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiCategoryNotificationConfiguration } from './InternalApiCategoryNotificationConfiguration';
import {
    InternalApiCategoryNotificationConfigurationFromJSON,
    InternalApiCategoryNotificationConfigurationFromJSONTyped,
    InternalApiCategoryNotificationConfigurationToJSON,
    InternalApiCategoryNotificationConfigurationToJSONTyped,
} from './InternalApiCategoryNotificationConfiguration';

/**
 * 
 * @export
 * @interface InternalApiUserAlertRfiMessageNotifications
 */
export interface InternalApiUserAlertRfiMessageNotifications {
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiUserAlertRfiMessageNotifications
     */
    categoryIds: Array<string>;
    /**
     * 
     * @type {Array<InternalApiCategoryNotificationConfiguration>}
     * @memberof InternalApiUserAlertRfiMessageNotifications
     */
    categoryConfigurations?: Array<InternalApiCategoryNotificationConfiguration>;
}

/**
 * Check if a given object implements the InternalApiUserAlertRfiMessageNotifications interface.
 */
export function instanceOfInternalApiUserAlertRfiMessageNotifications(value: object): value is InternalApiUserAlertRfiMessageNotifications {
    if (!('categoryIds' in value) || value['categoryIds'] === undefined) return false;
    return true;
}

export function InternalApiUserAlertRfiMessageNotificationsFromJSON(json: any): InternalApiUserAlertRfiMessageNotifications {
    return InternalApiUserAlertRfiMessageNotificationsFromJSONTyped(json, false);
}

export function InternalApiUserAlertRfiMessageNotificationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiUserAlertRfiMessageNotifications {
    if (json == null) {
        return json;
    }
    return {
        
        'categoryIds': json['categoryIds'],
        'categoryConfigurations': json['categoryConfigurations'] == null ? undefined : ((json['categoryConfigurations'] as Array<any>).map(InternalApiCategoryNotificationConfigurationFromJSON)),
    };
}

export function InternalApiUserAlertRfiMessageNotificationsToJSON(json: any): InternalApiUserAlertRfiMessageNotifications {
    return InternalApiUserAlertRfiMessageNotificationsToJSONTyped(json, false);
}

export function InternalApiUserAlertRfiMessageNotificationsToJSONTyped(value?: InternalApiUserAlertRfiMessageNotifications | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'categoryIds': value['categoryIds'],
        'categoryConfigurations': value['categoryConfigurations'] == null ? undefined : ((value['categoryConfigurations'] as Array<any>).map(InternalApiCategoryNotificationConfigurationToJSON)),
    };
}

